<template>
	<v-form ref="f">
		<v-container fluid>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-card-title class="headline ">Daily Revenue Report Storno</v-card-title>
						<v-container fluid>
							<v-row >
								<v-col class="pb-0" cols="6" >
									<a-hotel-select v-model="form.hotelCode"
											  	 :hotels="hotels"
											  	 :loading="preLoading"
											  	 @change="changeHotel">
									</a-hotel-select>
								</v-col>
								<v-col class="pb-0" cols="6" >
									<v-text-field v-model="form.reportDate"
												  label="Дата отчета"
												  :loading="preLoading"
												  color="secondary"
												  prepend-icon="event"
												  :rules="[v => !!v || 'Укажите дату']"
												  readonly>
									</v-text-field>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
			<v-row >
				<v-col cols="12">
					<v-card>
						<v-container fluid>
							<v-row >
								<v-col class="pb-0 pt-0" cols="12" >
									<v-btn color="primary"
										   @click="storno">
										Удалить данные
									</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
</template>


<script>
	import aHotelSelect from '../base/AHotelSelect.vue'
	import {api} from '../../lib/api'
	import {getMonthName} from '../../js/common.js'

	export default {
		components: {
			aHotelSelect
		},
		data: () => ({
			form: {
				reportDate: '',
				hotelCode: ''
			},
			hotels: null,
			preLoading: true,
		}),
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.apiFirstCall()

			setInterval(() => {
				this.apiFirstCall()
			}, 3600000)
		},
		computed: {
			reportDateShort() {
				if (!this.form.reportDate) return ''
				else {
					let d = new Date(this.form.reportDate)
					return (d.getDate() + ' ' + getMonthName(d.getMonth() + 1, 'R'))
				}
			},
			selectedHotel() {
				let i = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.form.hotelCode)
				return this.hotels[i]
			}
		},
		methods: {
			apiFirstCall: function () {
				api.post('drr/get_last_report_date', { hotels: this.hotels })
				.then(response => {

					this.hotels = response.data.hotels
					this.hotels.filter(hotel => hotel.maxDate)

					if (!this.form.hotelCode) {
						this.form.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
						this.changeHotel()
					}

					this.preLoading = false
				}, error => {})
			},
			storno: function () {
				this.$store.dispatch('dialogConfirm', {
					title: 'Вы уверены?',
					btnAcceptText: 'Да',
					btnDenyText: 'Назад'
				})
				.then(confirm => {
					if (confirm) {
						api.post('drr/storno_report', this.form)
						.then(response => {
							let d = new Date(this.selectedHotel.maxDate)
							d.setDate(d.getDate() - 1)
							this.selectedHotel.maxDate = d.toISOString().substr(0, 10)
							this.changeHotel()

							this.$store.dispatch('dialogLoadingStop')

							this.$store.dispatch('dialogDone')
						}, error => {})
						this.$store.dispatch('dialogLoadingStart')
					}
				})

			},
			changeHotel: function () {
				this.form.reportDate = this.selectedHotel.maxDate
			},
		}
	}
</script>
